import { useState } from 'react';
import Tabs from '@cloudscape-design/components/tabs';
import { MailHeaderTab } from '@components/MailHeaderTab';
import { AboutMailHeaderTab } from '@components/AboutMailHeaderTab';

const MailHeaderTool = () => {
  const [activeTabId, setActiveTabId] = useState('analyzer');

  return (
    <Tabs
      activeTabId={activeTabId}
      onChange={({ detail }) => setActiveTabId(detail.activeTabId)}
      tabs={[
        {
          id: 'analyzer',
          label: 'Analyze Mail Headers',
          content: <MailHeaderTab />,
        },
        {
          id: 'about',
          label: 'About Mail Headers',
          content: <AboutMailHeaderTab />,
        },
      ]}
    />
  );
};

export default MailHeaderTool;

